import React from 'react';
import { awardImages } from '../../../Data/data';
import GalleryList from '../../../Components/Globals/GalleryList';

const Awards = () => {
    return (
        <div className='flex w-full pb-8 justify-center'>
            <div className='w-full flex flex-col 520:max-w-[500px] max-w-[400px] px-4 520:px-0'>
                <div className='flex text-white py-8 text-2xl font-light uppercase'>
                    Awards
                </div>

                <GalleryList items={awardImages} />
            </div>
        </div>
    )
}

export default Awards